export const carouselInicio = [


    {
        "imagen" : "../Img/Banner3.png"
    },

     {
         "imagen" : "../Img/rutas.gif"
     },
     {
         "imagen" : "../Img/naranja.gif"
     },
     {
         "imagen" : "../Img/integridad.gif"
     }

]

